import {
  DatabaseItemLayoutType,
} from '@toolify/client/src/modules/databases/enum/DatabaseItemLayoutType'
import {
  IDatabaseItemLayoutByViewId,
} from '@toolify/client/src/modules/databases/types/IDatabaseItemLayoutByViewId'
import {
  MAX_DATABASE_ITEM_LAYOUT_VIEW_COUNT,
} from '@toolify/client/src/modules/databases/constants/maxDatabaseItemLayoutViewCount'

// The view just set moves to the end, so when the map is full the views touched longest ago drop out first.
export function setDatabaseItemLayoutForView(
  layoutByViewId: IDatabaseItemLayoutByViewId,
  viewId: string,
  layout: DatabaseItemLayoutType,
): IDatabaseItemLayoutByViewId {
  const entries = Object.entries(layoutByViewId).filter(([entryViewId]) => entryViewId !== viewId)
  entries.push([viewId, layout])
  return Object.fromEntries(entries.slice(-MAX_DATABASE_ITEM_LAYOUT_VIEW_COUNT))
}
